export default {"src":"/assets/_next/static/media/fr.6f4fd579.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};